// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604240653/js/" + chunkId + "." + {"44":"0a32f7e3","225":"be870474","481":"04a7957b","486":"90f0e8a5","770":"e2de212b"}[chunkId] + ".0.29398148543681635.chunk.js";
};